import { SelectionWithNoteMixin, SelectionWithSourceCitationMixin } from '../internal';
/**
 * @ignore
 */
export var SelectionWithNoteSourceCitationMixin = function (Base) { return SelectionWithSourceCitationMixin(SelectionWithNoteMixin(Base)); };
//# sourceMappingURL=SelectionWithNoteSourceCitationMixin.js.map